import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import { ButtonTransparentWhite } from '../../components/ButtonTransparentWhite';
import { ScreenBottomBar } from '../../components/ScreenBottomBar';

type Props = {
  onSkip(): void;
  onStart(): void;
};

export const DailySurveyReminder = (props: Props) => {
  return (
    <Wrapper>
      <ScreenBottomBar
        left={
          <Text weight="semibold" color="white">
            BMC Daily wellbeing survey
          </Text>
        }
        right={
          <Buttons>
            <ButtonTransparentWhite onPress={props.onSkip}>
              Skip Today
            </ButtonTransparentWhite>
            <Button onPress={props.onStart}>Start Survey</Button>
          </Buttons>
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled.View`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1000;
`;

const Buttons = styled.View`
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding-right: 100px;
`;
